import { useEffect, useState } from "react";
import api from "../lib/api";
import SEO from "../components/SEO";
import ArticleCard from "../components/ArticleCard";

export default function Magazine() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        api.get("/articles", { params: { limit: 50 } }).then((r) => setArticles(r.data)).catch(() => {});
    }, []);

    const [hero, ...rest] = articles;

    return (
        <>
            <SEO
            title="Magazine — articles & guides Normandie Picardie"
            description="Articles, dossiers et guides éditoriaux Côte Perdue : 48 heures parfaites entre Eu et Mers-les-Bains, hôtels chic Le Tréport / Cayeux, randonnées Forêt d'Eu, Vallée du Verre Bresle, Bois-de-Cise."
            path="/magazine"
        />
            <div className="pt-28" data-testid="magazine-page">
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pt-16 md:pt-24 pb-16">
                <p className="cp-tiny text-cp-foret mb-8">Chapitre V · Magazine</p>
                <h1 className="cp-serif text-4xl sm:text-5xl md:text-[56px] lg:text-[72px] xl:text-[92px] leading-[1.02] text-cp-encre max-w-5xl tracking-[-0.025em]">
                    Récits,<br /><em className="cp-display-italic text-cp-foret">reportages,</em> dossiers.
                </h1>
            </section>
            {hero && (
                <section className="px-6 md:px-12 max-w-[1400px] mx-auto pb-16">
                    <ArticleCard article={hero} variant="large" />
                </section>
            )}
            <section className="px-6 md:px-12 max-w-[1600px] mx-auto pb-32">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                    {rest.map((a) => <ArticleCard key={a.id} article={a} />)}
                </div>
            </section>
        </div>
    </>

    );
}
